import { combineReducers } from "redux";
import * as guid from "guid";
import * as _ from "lodash";
import admin from './admin'
import apps from './app'


const store = combineReducers({
    admin, apps
});

export default store;



// WEBPACK FOOTER //
// ./src/reducer/index.js